import React, { Component } from "react";
import {connect} from 'react-redux';
import BillingList from "../Components/Billing/BillingList.js";
import { billingService } from "../Services/BillingService.js";
import Grid from '@material-ui/core/Grid';

import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';

class BillingContainer extends Component {
	constructor(props){
		super(props);
		
		const d = new Date();
		let currentMonth = d.getMonth();
		
		this.state={
			processing: true,
			billing: [],
			month: currentMonth+1
		};
		this.downloadFile = this.downloadFile.bind(this);
		this.generaCsv = this.generaCsv.bind(this);
		this.downloadIcon = this.downloadIcon.bind(this);
		this.handleChangeMonth = this.handleChangeMonth.bind(this);
	}
	
	componentDidMount() {
		billingService.list()
					.then(response => this.setState({processing: false, billing: response.data}))
					.catch(err => {/*console.log(err);*/});
	}
	
	downloadFile(){
		const element = document.createElement("a");
		const file = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), this.generaCsv()], {type: "text/csv;charset=utf-8;"});
		element.href = URL.createObjectURL(file);
		element.download = "billing_"+this.state.month+".csv";
		document.body.appendChild(element);
		element.click();
	}
	
	generaCsv(){
		let haveReference=false;
		if(this.props.user.role=='CUSTOMER'){
			for(let i=0; i<this.state.billing.length; i++){
				for(let j=0; j<this.state.billing[i].lines.length; j++){
					if(this.state.billing[i].lines[j].reference){
						haveReference=true;
					}
				}
			}
		}
		const header = "Order;Order Total;CODE;"+(this.props.user.role=='CUSTOMER' ? "User;":"")+"Product;Document name;"+(this.props.user.role=='CUSTOMER' ? (haveReference ? "Reference;":""):"Customer;")+"Date;Units;Unit Price;Subtotal;Total\n"
		let csvData = header;
		for(let i=0; i<this.state.billing.length; i++){
			for(let j=0; j<this.state.billing[i].lines.length; j++){
				const line = this.state.billing[i].lines[j];
				csvData += this.state.billing[i].code+";"+this.state.billing[i].totalAmount.replace(".",",")+";"+line.code+";"+(this.props.user.role=='CUSTOMER' ? line.user+";":"")+line.product+";"+line.docName+";"+(this.props.user.role=='CUSTOMER' ? (haveReference ? line.reference+";":""):line.analiticAccount+";")+line.date.substring(0,10)+";"+line.qty+";"+line.unitPrice.replace(".",",")+";"+line.subtotal.replace(".",",")+";"+line.total.replace(".",",")+"\n";
			}
		}
		return csvData;
	}
	
	downloadIcon(){
		return <Tooltip title="Download CSV"><Icon onClick={this.downloadFile} style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#27ae60", cursor: "pointer"}}>&#59408;</Icon></Tooltip>
	}
	
	handleChangeMonth(e){
		e.preventDefault();
		const {name, value} = e.target;
		this.setState({processing: true, month:value});
		billingService.list(value)
					.then(response => this.setState({processing: false, billing: response.data}))
					.catch(err => {/*console.log(err);*/});
	}
	
	monthSelect(){
		const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
		const options=monthNames.map((element, index) => {
															if(index+1==this.state.month){return <option selected="selected" value={index+1}>{element}</option>}
															else{return <option value={index+1}>{element}</option>}
														});
		return  <select onChange={this.handleChangeMonth} name="month" id="month">{options}</select>
	}
	
	render() {
		if(this.state.processing){
			return <div className="content">PROCESSING...</div>
		}else{
			return (<div className="content">
					<h2 className="title">{this.downloadIcon()} BILLING <span style={{marginLeft: "25px"}}>{this.monthSelect()}</span></h2>
					<BillingList
						billing={this.state.billing}
						role = {this.props.user.role}
						search = {this.props.search}
					/>
					</div>);
		}
	}
}

function mapStateToProps(state, ownProps) {
	return {user: state.user, search: state.search.searchString}
}

export default connect(mapStateToProps)(BillingContainer);  